<app-heading [title]="'Active job postings'" [button]="false" [isbreadcrumb]="false" [showToggle]="false"></app-heading>

<div class="card">
    <div class="grid grid-nogutter align-items-center mb-4">
        <div class="col-12 flex align-items-center gap-3">
            <div class="col-12 md:col-6 xl:col-2 lg:col-6 sm:col-12 p-0">
                <p-iconField iconPosition="right">
                    <p-inputIcon styleClass="pi pi-search" />
                    <input [(ngModel)]="searchTextValue" (ngModelChange)="onSearch()" type="text" pInputText
                        [attr.disabled]="searchFieldDisabled() ? true : null"
                        [placeholder]="'Search jobs' | sentenceCase" />
                </p-iconField>
            </div>
            
            <ng-container *ngIf="selectedSearchField.value === 'rate'">
                <div class="flex flex-column gap-1">
                    <div class="flex align-items-center pl-2">
                        <p-checkbox inputId="notSpecified" [(ngModel)]="notSpecifiedValue"
                            [binary]="true"
                            (onChange)="searchTextValue=''; onRateFilterChange();"></p-checkbox>
                        <label for="notSpecified" class="ml-2">Not Specified</label>
                    </div>
                    <div class="flex align-items-center pl-2">
                        <p-checkbox inputId="byExperience" [(ngModel)]="byExperienceValue"
                            [binary]="true"
                            (onChange)="searchTextValue=''; onRateFilterChange();"></p-checkbox>
                        <label for="byExperience" class="ml-2">Depends On Experience</label>
                    </div>
                </div>
            </ng-container>
            <div class="flex align-items-center gap-2">
               <p-dropdown
                    [options]="searchFieldOptions"
                    [(ngModel)]="selectedSearchFieldValue"
                    (onChange)="onSearchFieldChange($event)"
                    optionLabel="name"
                    placeholder="Search By"
                    styleClass="mr-2"
                    [style]="{'min-width': '200px'}"
                    class="w-full">
                </p-dropdown>
                <p-button
                    [icon]="sortDirection === 'asc' ? 'pi pi-sort-alpha-up' : 'pi pi-sort-alpha-down'"
                    [pTooltip]="sortDirection === 'asc' ? 'Ascending' : 'Descending'"
                    tooltipPosition="top"
                    (click)="toggleSortDirection()"
                    [outlined]="true"
                    size="small"
                    styleClass="sort-direction-btn"
                ></p-button>
            </div>
            <small class="sort-info text-xs text-500 mt-1 block">
                {{ sortDisplayText }}
            </small>
            <p-button class="flex flex-column gap-1 pl-3" label="go" [rounded]="true" size="small" (click)="onSearch()" class="pl-2"></p-button>
        </div>
    </div>
    <p-table [value]="jobs"
        dataKey="_id"
        [expandedRowKeys]="expandedRows"
        [totalRecords]="jobsCount"
        styleClass="p-datatable-sm p-datatable-sm--normal"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
        [lazy]="true"
        (onLazyLoad)="onPageChange($event)">
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Start date</th>
                <th>Published At</th>
                <th>Location</th>
                <th>Rate</th>
                <th style="width: 5rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-job let-expanded="expanded">
            <tr>
                <td>{{ job.title }}</td>
                <td>{{ job.startDate | date: 'MM/dd/yyyy' }}</td>
                <td>
                  <ng-container *ngIf="job.publishedAt">
                    {{ job.publishedAt | date: 'MM/dd/yyyy' }}
                  </ng-container>
                  <ng-container *ngIf="!job.publishedAt">
                    <span class="text-muted">Not published</span>
                  </ng-container>
                </td>
                <td>{{ getLocation(job) }}</td>
                <td>
                    <ng-container *ngIf="job.rateRange?.rateMinimum">
                        ${{ job.rateRange.rateMinimum }} - ${{ job.rateRange.rateMaximum }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                    </ng-container>
                    <ng-container *ngIf="job.rate && !job.rateRange?.rateMinimum">
                        {{ job.rate }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                    </ng-container>
                    <ng-container *ngIf="!job.rate && job.rateOption === 'experience'">Depends On Experience</ng-container>
                    <ng-container *ngIf="job.rateOption === '' || job.rateOption === 'none'">Not Specified</ng-container>
                </td>
                <td>
                    <p-button [ngStyle]="{'margin-left': 'auto'}" [pTooltip]="expanded? 'Close' : 'Expand'" 
                        tooltipPosition="top" type="button" [pRowToggler]="job" pRipple [text]="true"
                            [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" 
                            [size]="'large'" class="row-toggler" />
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-job>
            <tr>
                <td colspan="7" class="surface-100">
                    <div class="py-3">
                        <div>
                            <div class="flex flex-column gap-3">
                                <div class="grid">
                                    <div class="col-6 lg:col-4 flex flex-column">
                                        <span class="text-xs text-primary-900 font-medium">Start date</span>
                                        <span class="text-black-alpha-60">{{ job.startDate | date: 'MM/dd/yyyy' }}</span>
                                    </div>
                                    <div class="col-6 lg:col-4 flex flex-column">
                                        <span class="text-xs text-primary-900 font-medium">Rate</span>
                                        <span class="text-black-alpha-60">
                                            <ng-container *ngIf="job.rateRange?.rateMinimum">
                                                ${{ job.rateRange.rateMinimum }} - ${{ job.rateRange.rateMaximum }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                                            </ng-container>
                                            <ng-container *ngIf="job.rate && !job.rateRange?.rateMinimum">
                                                {{ job.rate }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                                            </ng-container>
                                            <ng-container *ngIf="!job.rate && job.rateOption === 'experience'">Depends On Experience</ng-container>
                                            <ng-container *ngIf="job.rateOption === '' || job.rateOption === 'none'">Not Specified</ng-container>
                                        </span>
                                    </div>
                                    <div class="col-6 lg:col-4 flex flex-column">
                                        <span class="text-xs text-primary-900 font-medium">Location</span>
                                        <span class="text-black-alpha-60">
                                            <span *ngIf="job.isRemote">Remote</span>
                                            <span *ngIf="!job.isRemote">{{ job.city }}, {{ job.state }}, {{ job.postalCode }}</span>
                                        </span>
                                    </div>
                                    <div class="col-6 lg:col-4 flex flex-column" *ngIf="job.company">
                                        <span class="text-xs text-primary-900 font-medium">Company</span>
                                        <span class="text-black-alpha-60">{{ job.company }}</span>
                                    </div>
                                </div>
                                <div class="mt-2 flex gap-2">
                                    <p-button label="description" (click)="openDetailModal(job, 'description')" [rounded]="true" size="small"></p-button>
                                    <p-button label="requirements" (click)="openDetailModal(job, 'requirement')" [rounded]="true" size="small"></p-button>
                                    <p-button label="responsibilities" (click)="openDetailModal(job, 'responsibility')" [rounded]="true" size="small"></p-button>
                                    <p-button *ngIf="job.alreadyApplied" [disabled]="true" label="already applied" class="p-button-success" (click)="apply(job)" [rounded]="true" size="small"></p-button>
                                    <p-button *ngIf="!job.alreadyApplied" label="apply" class="p-button-success" (click)="apply(job)" [rounded]="true" size="small"></p-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-dialog [header]="detailModalHeader" [modal]="true" [(visible)]="detailModalVisible" [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    <p class="mt-2 break-words" style="white-space: pre-line; word-break: break-word;" [innerHTML]="sanitizer.bypassSecurityTrustHtml(detailModalContent)"></p>
</p-dialog>
<p-dialog [(visible)]="applyModalVisible" [modal]="true" [header]="applyModalHeader" [style]="{width: '50vw'}" [closable]="false">
  <div class="p-1">
    <div class="mb-4">
      <div *ngIf="pendingApplyJob">
        <div>
            <div class="mb-3">
            You are applying for {{pendingApplyJob.title}}. Your current {{appName}} profile and resume will be submitted with this application. If you’d like to make any changes to either please do so prior to application.
            </div>
            <div><strong>Title:</strong> {{pendingApplyJob.title || ''}}</div>
            <div *ngIf="pendingApplyJob.company"><strong>Company:</strong> {{pendingApplyJob.company}}</div>
            <div *ngIf="pendingApplyJob.isRemote"><strong>Location:</strong> Remote</div>
            <div *ngIf="!pendingApplyJob.isRemote && (pendingApplyJob.city || pendingApplyJob.state)">
                <strong>Location:</strong> {{pendingApplyJob.city}}{{pendingApplyJob.city && pendingApplyJob.state ? ', ' : ''}}{{pendingApplyJob.state}}{{pendingApplyJob.postalCode ? ', ' + pendingApplyJob.postalCode : ''}}
            </div>
            <div *ngIf="pendingApplyJob.rateRange?.rateMinimum">
                <strong>Rate/Salary:</strong> {{pendingApplyJob.rateRange.rateMinimum}} - {{pendingApplyJob.rateRange.rateMaximum}}{{pendingApplyJob.rateOption === 'hourly' ? '/hour' : '/year'}}
            </div>
            <div *ngIf="pendingApplyJob.rate && !pendingApplyJob.rateRange?.rateMinimum">
                <strong>Rate/Salary:</strong> {{pendingApplyJob.rate}}{{pendingApplyJob.rateOption === 'hourly' ? '/hour' : '/year'}}
            </div>
            <div *ngIf="!pendingApplyJob.rate && pendingApplyJob.rateOption === 'experience'">
                <strong>Rate/Salary:</strong> Depends On Experience
            </div>
            <div *ngIf="pendingApplyJob.rateOption === '' || pendingApplyJob.rateOption === 'none'">
                <strong>Rate/Salary:</strong> Not Specified
            </div>
            <div>
            <div class="mt-2"><strong>Description:</strong><br>
                <span *ngIf="pendingApplyJob.description" class="staftr-word-wrap" [innerHTML]="sanitizer.bypassSecurityTrustHtml(pendingApplyJob.description)"></span>
                <span *ngIf="!pendingApplyJob.description">
                    No description available
                </span>
            </div>
            </div>
            <div>
            <div class="mt-2"><strong>Responsibilities:</strong><br>
                <span *ngIf="pendingApplyJob.responsibility" class="staftr-word-wrap" [innerHTML]="sanitizer.bypassSecurityTrustHtml(pendingApplyJob.responsibility)"></span>
                <span *ngIf="!pendingApplyJob.responsibility">
                    No responsibility available
                </span>
            </div>
            </div>
            <div>
            <div class="mt-2"><strong>Requirements:</strong><br>
                <span *ngIf="pendingApplyJob.requirement" class="staftr-word-wrap" [innerHTML]="sanitizer.bypassSecurityTrustHtml(pendingApplyJob.requirement)"></span>
                <span *ngIf="!pendingApplyJob.requirement">
                    No requirements available
                </span>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="flex justify-content-end gap-2">
      <p-button label="cancel" class="p-button-secondary" (onClick)="onCancelApply()"></p-button>
      <p-button label="apply" class="p-button-success" (onClick)="onApplyConfirm()"></p-button>
    </div>
  </div>
</p-dialog>
<p-dialog [(visible)]="screeningModalVisible" [modal]="true" [header]="'Screening Question'" [closable]="false" [style]="{width: '30vw'}">
  <div class="p-3">
    <div class="mb-4">{{ screeningQuestion }}</div>
    <div class="flex justify-content-end gap-2">
      <p-button label="no" class="p-button-secondary" (onClick)="onScreeningAnswer(false)"></p-button>
      <p-button label="yes" class="p-button-success" (onClick)="onScreeningAnswer(true)"></p-button>
    </div>
  </div>
</p-dialog>